import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DownloadPlanRequest, DownloadPlanResponse } from '../interfaces/download-plan.model';
import { ApiResponse } from '../interfaces/api-response.model';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api.constants';

@Injectable({
  providedIn: 'root',
})
export class DownloadPlanService {
  http: HttpClient = inject(HttpClient);


  /**
   * 下載確認方案表 (CB-008)
   * @param request 
   */
  downloadPlan(
    request: DownloadPlanRequest
  ): Observable<HttpResponse<Blob>> {
    return this.http.post(
      API_ENDPOINTS.DOWNLOAD_PLAN,
      request,
      {
        responseType: 'blob',
        observe: 'response'
      }
    );
  }
}
